import React, { useState } from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import api from "../api";
import ReactGA from "react-ga4";
import "./style/SocialGallery.css";

/**
 * Like toggle for a social post.
 * Opens LoginPromptModal when the user is not authenticated.
 *
 * Props:
 *   photoId        number
 *   liked          bool
 *   count          number
 *   authenticated  bool
 *   onLoginRequired () => void   — called when not logged in
 *   onToggled      (liked, count) => void
 */
export default function SocialLikeButton({
  photoId,
  liked,
  count,
  authenticated,
  onLoginRequired,
  onToggled,
}) {
  const [loading, setLoading] = useState(false);

  async function handleClick() {
    if (!authenticated) {
      onLoginRequired();
      return;
    }
    if (loading) return;
    setLoading(true);
    try {
      const res = await api.post(`/social/like/${photoId}`);
      if (res.data.success) {
        ReactGA.event({ category: 'engagement', action: 'social_like' });
        onToggled(res.data.liked, res.data.count);
      }
    } catch {
      // silent — server will 401 if session expired
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      className={`social-action-btn ${liked ? "social-action-btn--liked" : ""}`}
      onClick={handleClick}
      disabled={loading}
      aria-label={liked ? "Unlike" : "Like"}
    >
      {liked ? <FaHeart size={18} /> : <FaRegHeart size={18} />}
      {count > 0 && <span className="social-action-btn__count">{count}</span>}
    </button>
  );
}
